<!--Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.-->
<header class="header">
  <div class="container">
    <nav class="navbar">
      <div class="logo">
        <a routerLink="/">
          <img src="../../../assets/images/sadiant-logo.png"
               alt="Sadiant Health"
               width="200"
               height="40">
        </a>
      </div>

      <div class="nav-links">
        <a routerLink="/about-us"
           [routerLinkActive]="'active'">ABOUT US</a>
        <a routerLink="/facilities"
           [routerLinkActive]="'active'">FACILITIES</a>
        <a routerLink="/clinicians"
           [routerLinkActive]="'active'">CLINICIANS</a>
        <!-- <a routerLink="/news"
           [routerLinkActive]="'active'">NEWS</a> -->
        <a routerLink="/contact"
           [routerLinkActive]="'active'">CONTACT</a>
      </div>

      <div class="nav-actions">
        <button #signInBtn
                pButton
                label="SIGN IN"
                class="p-button-primary make-jobs-btn"
                (mouseenter)="onSignInHoverOpen($event)"
                (mouseleave)="onSignInHoverClose()"
                (click)="onSignInClickToggle($event)">
        </button>

        <!-- Overlay Dropdown -->
        <p-overlayPanel #signInMenu
                        [appendTo]="'body'">
          <div class="signin-dropdown"
               (mouseenter)="cancelSignInHoverClose()"
               (mouseleave)="signInMenu.hide()">

            <a [href]="clinicianPortalUrl"
               (click)="signInMenu.hide()">Clinicians</a>
            <a [href]="clientPortalUrl"
               (click)="signInMenu.hide()">Facilities</a>

          </div>
        </p-overlayPanel>
        <!-- <button pButton
                label="Sign Up"
                class="p-button-coral sign-up-btn"
                [routerLink]="'/sign-up'"></button> -->
        <button pButton
                label="Apply Here"
                (click)="goToExternal('https://careers.sadianthealth.com/#/jobs')"
                class="p-button-coral sign-up-btn"></button>
      </div>

      <button class="mobile-menu-btn"
              (click)="toggleMobileMenu()">
        <i class="pi pi-bars"></i>
      </button>
    </nav>
  </div>

  <div class="mobile-menu"
       [class.active]="mobileMenuOpen">
    <div class="mobile-nav-links">
      <a routerLink="/about-us"
         (click)="closeMobileMenu()">ABOUT US</a>
      <a routerLink="/facilities"
         (click)="closeMobileMenu()">FACILITIES</a>
      <a routerLink="/clinicians"
         (click)="closeMobileMenu()">CLINICIANS</a>
      <!-- <a routerLink="/news"
         (click)="closeMobileMenu()">NEWS</a> -->
      <a routerLink="/contact"
         (click)="closeMobileMenu()">CONTACT</a>
      <button pButton
              type="button"
              label="SIGN IN"
              class="p-button-primary make-jobs-btn"
              (click)="onSignInClickToggle($event)"></button>
      <!-- <button pButton
              type="button"
              label="SIGN UP"
              class="p-button-coral"
              [routerLink]="'/sign-up'"
              (click)="closeMobileMenu()"></button> -->
      <button pButton
              type="button"
              label="Apply Here"
              (click)="goToExternal('https://careers.sadianthealth.com/#/jobs')"
              class="p-button-coral sign-up-btn"></button>
    </div>
  </div>
</header>
